import {
  Grid,
  Box,
  FormControl,
  FormLabel,
  VStack,
  Button,
  Spinner,
  useToast,
  Heading,
} from "@chakra-ui/react";
import { Select } from "chakra-react-select";
import { useState, useEffect } from "react";
import ItemBox from "../ItemBox/ItemBox";
import { useNavigate } from "react-router-dom";
import ItemBoxSkeleton from "../ItemBox/ItemBoxSkeleton";
import { TARM_AWS_URL } from "../../api/api";
import axios from "axios";
import { w3cwebsocket } from 'websocket'
import { getRunID } from "../../util/runID";

const WS_ENDPOINT = 'wss://puwootkcbg.execute-api.us-east-1.amazonaws.com/production/'
const MatchJobProfile = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const [source] = useState(axios.CancelToken.source());
  const [selectedJobProfile, setSelectedJobProfile] = useState(null);
  const [allJobProfiles, setAllJobProfiles] = useState([]);
  const [topJobProfiles, setTopJobProfiles] = useState([]);
  const [selectedResumePools, setSelectedResumePools] = useState([]);
  const [allResumePools, setAllResumePools] = useState([]);
  const [topResumePools, setTopResumePools] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [websocket, setWebsocket] = useState(null);
  const [readyState, setReadyState] = useState(WebSocket.CLOSED);


  useEffect(() => {
    console.log(`readyState: ${readyState}`);
  }, [readyState]);

  useEffect(() => {
    const newWebsocket = new WebSocket(WS_ENDPOINT);
    setReadyState(WebSocket.CONNECTING);
    newWebsocket.onopen = () => setReadyState(WebSocket.OPEN);
    newWebsocket.onclose = () => setReadyState(WebSocket.CLOSED);
    setWebsocket(newWebsocket);
    // const socket = new WebSocket();
    // socket.onopen = () => {
    //   console.log('WebSocket connected');
    // };
    fetchPoolsAndJobProfiles();

    return () => {
      // websocket.close();
      if (source) {
        source.cancel();
      }
    };
  }, []);

  const serializeData = (arr) => {
    const newArr =
      arr.map(item => ({ ...item, label: item['PK'], value: item['PK'] }))
    console.log(newArr)
    return newArr
  }

  const fetchPoolsAndJobProfiles = async () => {
    try {
      const response = await TARM_AWS_URL.get("jd-parser/get-pools-jds-count", {
        cancelToken: source.token,
      });
      setTopJobProfiles(response.data.jd);
      setTopResumePools(response.data.pool);
      setAllJobProfiles(serializeData(response.data.jd));
      setAllResumePools(serializeData(response.data.pool));
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      toast({
        title: err.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchRankingWS = (selectedJobProfile, selectedPools) => {
    console.log(selectedJobProfile)
    console.log(selectedPools)
    setIsBtnLoading(true);
    websocket.send(JSON.stringify(
      {
        "action": "sendMessage",
        "pools": selectedPools,
        "jd": selectedJobProfile
      }
    ))
    websocket.onmessage = async (event) => {
      console.log('Message from server EVENT:');
      console.log(JSON.parse(event.data))
      const data = JSON.parse(event.data)
      if (data === 'success') {
        try {
          const response = await TARM_AWS_URL.get('get-pools-jd-ranking', { params: { jd_run_id: selectedJobProfile.run_id } })
          console.log(response)
          navigate("result", {
            state: {
              rowData: response.data["ranking_output"],
              skillsCount: response.data["max_matched_skills"],
              scoreCount: response.data["interpretation_counts"],
              // maxMatchedSkills: response.data["max_matched_skills"],
              totalCandidates: response.data["ranking_output"].length,
              selectedJobProfile: selectedJobProfile,
              selectedResumePools: selectedResumePools,
            },
          });
        } catch (error) {
          toast({
            title: error.message,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        } finally {
          setIsBtnLoading(false);
        }
      } else {
        toast({
          title: data?.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setIsBtnLoading(false);
      }
    };
  }

  const fetchRanking = async (selectedJobProfile, selectedPools) => {
    setIsBtnLoading(true);
    try {
      const response = await TARM_AWS_URL.post(
        "jd-parser/get-jd-ranking",
        {
          pools: selectedPools,
          jd: selectedJobProfile,
        },
        {
          cancelToken: source.token,
        }
      );
      console.log(response.data);
      const selectedJobProfileFilteredArr = topJobProfiles.filter(jp => jp.PK === selectedJobProfile)
      console.log(selectedJobProfileFilteredArr)
      let unRankedPools = response.data["Unranked Pools"]
      if (unRankedPools.length > 0) {
        unRankedPools = topResumePools.filter((pool) => {
          return unRankedPools.some((p) => {
            return p === pool.PK;
          });
        })
      }
      navigate("result", {
        state: {
          rowData: response.data.Items,
          skillsCount: response.data["Skills Count"],
          scoreCount: response.data["Score Count"],
          maxMatchedSkills: response.data["Max Matched Skills"],
          totalCandidates: response.data.Items.length,
          selectedJobProfile: selectedJobProfileFilteredArr[0],
          selectedResumePools: selectedResumePools,
          unRankedPools: unRankedPools
        },
      });
    } catch (error) {
      console.error(error);
      toast({
        title: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsBtnLoading(false);
    }
  };

  const handleResumePoolChange = (selectedItems) => {
    if (selectedItems.length > 5) return;
    setSelectedResumePools(selectedItems);
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    if (!(selectedJobProfile && selectedResumePools.length)) return;
    const selectedPools = selectedResumePools.map((item) => item.value);
    // fetchRanking(selectedJobProfile.value, selectedPools);
    fetchRankingWS(selectedJobProfile, selectedResumePools)
  };

  return (
    <VStack>
      <Heading>Match a job profile with existing pools</Heading>
      <br />
      {isLoading && <ItemBoxSkeleton />}

      {!isLoading && (
        <>
          <Grid templateColumns="repeat(3, 1fr)" gap={3}>
            {topJobProfiles.slice(0, 6).map((jp) => (
              <ItemBox label={jp.PK} value={jp.resumes} key={jp.PK} />
            ))}

          </Grid>
          <Grid templateColumns="repeat(3, 1fr)" gap={3}>
            {topResumePools.slice(0, 6).map((pool) => (
              <ItemBox label={pool.PK} value={pool.resumes} key={pool.PK} />
            ))}
          </Grid>
        </>

      )}

      <form onSubmit={handleSubmit}>
        <Grid templateColumns="repeat(2, 1fr)" gap={10} pt={10}>
          <Box width={350}>
            <FormControl isRequired>
              <FormLabel>Please select job profile</FormLabel>
              <Select
                isMulti={false}
                name="jobProfiles"
                options={allJobProfiles}
                placeholder="Search"
                closeMenuOnSelect={true}
                value={selectedJobProfile}
                onChange={(selectedItem) => setSelectedJobProfile(selectedItem)}
              />
            </FormControl>
          </Box>
          <Box width={350}>
            <FormControl isRequired>
              <FormLabel>Please select resume pool</FormLabel>
              <Select
                isMulti
                name="resumePool"
                options={allResumePools}
                placeholder="Search"
                value={selectedResumePools}
                closeMenuOnSelect={false}
                onChange={(selectedItems) =>
                  handleResumePoolChange(selectedItems)
                }
              />
            </FormControl>
            <Box textAlign="end" mt="4">
              <Button
                type="submit"
                colorScheme="blue"
                disabled={
                  !(selectedJobProfile && selectedResumePools.length) ||
                  isBtnLoading
                }
              >
                {isBtnLoading && <Spinner size="sm" mr={2} />}
                Next
              </Button>
            </Box>
          </Box>
        </Grid>
      </form>
    </VStack>
  );
};

export default MatchJobProfile;
